import { selectMachinePartModalOptions as componentOptions } from "./component";
export * from "./component";
export default componentOptions;
